import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { RefreshHolidayService } from 'app/core/services/refresh-holiday/refresh-holiday.service';
import { RefreshScalelineService } from 'app/core/services/refresh-scaleline/refresh-scaleline.service';

@Component({
  selector: 'dialog-doc-action-payroll',
  templateUrl: './dialog-doc-action-payroll.component.html',
  styleUrls: ['./dialog-doc-action-payroll.component.scss']
})
export class DialogDocActionPayrollComponent implements OnInit {

  isLoading: boolean = false;
  statusList: any[] = [];
  status: string = '';

  constructor(public dialogRef: MatDialogRef<DialogDocActionPayrollComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollProcessService: PayrollProcessService,
    private refreshScaleLineService: RefreshScalelineService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    if (this.data.docStatus === 'In Progress') {
      this.status = 'IP';
    }
    if (this.data.docStatus === 'Complete') {
      this.status = 'CO';
    }
    this.getDocStatuses();
  }

  getDocStatuses() {
    this.payrollProcessService.getDocStatuses().subscribe({
      next: res => {
        this.statusList = res;
        this.statusList = res.filter((status: any) => status.value !== 'RE');
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    this.payrollProcessService.docActionPayroll(this.status, this.data.id).subscribe({
      next: res => {
        this.refreshScaleLineService.emitRefresh2(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading = false;
      }
    })
  }
}
